import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenesysCloudPlatformApiService } from '../../common/services/genesys-cloud-platform-api.service';
import { QueueSearchResponse } from '../models/queue-search-response.model';

@Injectable({
  providedIn: 'root'
})
export class QueueApiService {
  static readonly SearchQueuesPath = 'api/v2/routing/queues/divisionviews';

  constructor(private readonly api: GenesysCloudPlatformApiService) {
  }

  searchQueues$(searchTerm: string, pageSize: number, pageNumber: number): Observable<QueueSearchResponse> {
    return this.api.get$<QueueSearchResponse>(QueueApiService.SearchQueuesPath, {
      params: {
        sortBy: 'name',
        name: searchTerm,
        pageSize: pageSize,
        pageNumber: pageNumber
      }
    });
  }

  getAllQueues$(pageSize: number, pageNumber: number): Observable<QueueSearchResponse> {
    return this.api.get$<QueueSearchResponse>(QueueApiService.SearchQueuesPath + '/all', {
      params: {
        pageSize: pageSize,
        pageNumber: pageNumber,
        sortOrder: 'asc'
      }
    });
  }
}
